/**
 * API CEI Apps
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `EM_ANDAMENTO` - Em Andamento * `CONCLUIDO` - Concluído
 */
export enum SituacaoD47Enum {

    EM_ANDAMENTO = 'EM_ANDAMENTO',

    CONCLUIDO = 'CONCLUIDO'
}

